import React from 'react';
import { FaTh, FaTimes, FaPlus } from 'react-icons/fa';

interface MultiviewButtonProps {
  isActive: boolean;
  selectedCount: number;
  maxStreams: number;
  onToggle: () => void;
  onOpen?: () => void;
  onClear?: () => void;
}

const MultiviewButton: React.FC<MultiviewButtonProps> = ({
  isActive,
  selectedCount,
  maxStreams,
  onToggle,
  onOpen,
  onClear
}) => {
  return (
    <div className="multiview-button-container">
      <button 
        className={`multiview-toggle-btn ${selectedCount > 0 && !isActive ? 'has-selection' : ''} ${isActive ? 'active' : ''}`}
        onClick={onToggle}
        title={selectedCount > 0 && !isActive ? 'Mode sélection actif' : isActive ? 'Désactiver la sélection' : 'Activer la sélection'}
      >
        <FaTh />
        <span>{isActive ? 'Sélection active' : 'Sélectionner'}</span>
        {selectedCount > 0 && (
          <span className="selection-count">({selectedCount}/{maxStreams})</span>
        )}
      </button>

      {selectedCount > 0 && onOpen && (
        <button 
          className="multiview-open-btn"
          onClick={() => {
            console.log('Open button clicked with', selectedCount, 'streams');
            onOpen();
          }}
          title="Ouvrir le multiview"
        >
          <FaPlus />
          <span>Ouvrir Multiview</span>
        </button>
      )}
      
      {selectedCount > 0 && onClear && (
        <button 
          className="multiview-clear-btn"
          onClick={onClear}
          title="Vider la sélection"
        >
          <FaTimes />
        </button>
      )}

      {isActive && selectedCount < maxStreams && (
        <div className="multiview-help">
          <FaPlus />
          <span>Cliquez sur les + pour ajouter des streams</span>
        </div>
      )}

      {selectedCount > 0 && !isActive && (
        <div className="multiview-help">
          <span>{selectedCount} stream{selectedCount > 1 ? 's' : ''} sélectionné{selectedCount > 1 ? 's' : ''}</span>
        </div>
      )}
    </div>
  );
};

export default MultiviewButton;